export default __webpack_public_path__ + "static/media/design_left.573272c1.png";